import { ChangeDetectorRef, Component, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WizardNavigationComponent } from '../../../../shared/components/wizard-navigation/wizard-navigation.component';
import { LinkCellComponent, TableColumn, TableComponent, TextInputComponent } from 'ddmo-storybook-lib';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '../../../../shared/services/shared.service';
import { MatPaginator } from '@angular/material/paginator';
import { W9AlertComponent } from '../../../popups/processing/processing.component';
import { LoaderService } from '../../../../shared/services/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { DocumentPreviewComponent } from '../../../landing/pages/document/document-modal.compoment';
import { DentalCredentialsService } from '../../services/dental-credentials.service';
import { PopupComponent } from '../popup/popup.component';
import { DocumentCategory, DocumentSubCategory, DocumentSubCategoryName } from '../../../../shared/constants/document.constants';
import { v4 as uuidv4 } from 'uuid';
import { UploadTriggerComponent } from '../../../../shared/components/upload-trigger/upload-trigger.component';


interface Location {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  participating: boolean;
}
interface TinPayee {
  id: number;
  tin: string;
  taxEntityName: string;
  address: string;
  payeeAddress: string;
}
@Component({
  selector: 'app-location',
  imports: [CommonModule, FormsModule, WizardNavigationComponent, TableComponent, TextInputComponent, MatPaginator, UploadTriggerComponent],
  templateUrl: './location.component.html',
  styleUrl: './location.component.scss'
})

export class LocationComponent {
  @ViewChild('locationPaginator') paginator!: MatPaginator;
  @ViewChild('tinTableWrapper', { static: false }) tinTableWrapper!: ElementRef<HTMLElement>;
  @ViewChild('w9Uploader') w9Uploader!: UploadTriggerComponent;
  locations: any = [];
  filteredLocations: any = [];
  tinData: any[] = [];
  originalTinData: any[] = [];
  tinFilterText: string = '';
  public tableData: any = []
  totalRecords: number = 0;
  tinTotalRecords: number = 0;
  currentTinPageIndex = 0;
  currentTinPageSize = 5;
  readonly tinFetchPageSize = 50;
  public dataSource = new MatTableDataSource<any>([]);
  tinDataSource = new MatTableDataSource<any>([]);
  public tableColumns: TableColumn[] = [{
    columnId: 'delete',
    columnLabel: '',
    sort: false,
    headerData: null,
    columnData: {
      cellType: LinkCellComponent,
      data: {
        label: '',
        actionData: "locationId",
      },
      otherParams: 'delete'
    },
    caseInsensitive: false,
  },
  {
    columnId: 'status',
    columnLabel: 'Existing',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: false
  },
  {
    columnId: 'name',
    columnLabel: 'Location name',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: true,
  },
  {
   columnId: 'tin',
   columnLabel: 'TIN',
   sort: true,
   headerData: null,
   columnData: null,
   caseInsensitive: false,
  },
  {
   columnId: 'effectiveDate',
    columnLabel: 'Effective date',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: false,
  },
  {
    columnId: 'address1',
    columnLabel: 'Address',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: true,
  },
  {
    columnId: 'city',
    columnLabel: 'City',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: true,
  },
  {
    columnId: 'state',
    columnLabel: 'State',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: true,
  },
  {
    columnId: 'participating',
    columnLabel: 'Participating',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: true,
  },
  {
    columnId: 'Primary',
    columnLabel: 'Primary',
    sort: true,
    headerData: null,
    columnData: null,
    caseInsensitive: false
  },
  {
    columnId: 'action',
    columnLabel: 'Action',
    sort: false,
    headerData: null,
    columnData: {
      cellType: LinkCellComponent,
      data: {
        label: 'Edit',
        actionData: 'locationId',
      },
      otherParams: 'edit'
    },
    caseInsensitive: false,
  },
  {
    columnId: 'documents',
    columnLabel: '',
    sort: false,
    headerData: null,
    columnData: {
      cellType: LinkCellComponent,
      data: {
        label: 'description',
        actionData: 'locationId',
      },
      otherParams: {
        'actionKey': 'documents'
      }
    },
    caseInsensitive: false,
  }
  ];
  pagedLocationData: any[] = [];
  currentPageIndex = 0;
  currentPageSize = 5;
  isRecred: boolean = false;
  action: any
  hasWhLocation: boolean = false;
  impersonatedUser: any = localStorage.getItem("impersonatedUser") ?? ""
  totalDisplayLength = 0;
  totalPages = 0;
  pageNumber: number = 1;
  accept = 'application/pdf';
  selectedTinForW9Upload: any = null;
  private locationDirectories: any[] = [];
  private hasLoadedDocuments = false;
  private w9DocumentIds = new Set<number>();
  private readonly directoryRequiredQuestions = [
    'hasWeekendHours',
    'hasEarlyMorningHours',
    'hasLateEveningHours',
    'hasEmergencyPhoneNumber',
    'hasPublicTransitNearby',
    'hasDisabledAdultCare',
    'hasDisabledChildrenCare'
  ];
  @ViewChild('tableWrapper', { static: false }) tableWrapper!: ElementRef<HTMLElement>;
  get showInitialEmptyState(): boolean {
    return !this.isRecred && (!this.locations || this.locations.length === 0);
  }
  constructor(private router: Router, private renderer: Renderer2, private service: SharedService, private loader: LoaderService, public dialog: MatDialog,private cdr: ChangeDetectorRef, private dentalCredentialingService: DentalCredentialsService) { }

  private getModifiedDateTime(row: any): number {
    const value = row?.modifiedDate;
    if (!value) return 0;
    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  private sortLocationsWithTopPriority(locations: any[]): any[] {
    return [...locations].sort((a: any, b: any) => {
      const aIsNew = a?.delete === 'delete';
      const bIsNew = b?.delete === 'delete';

      if (aIsNew !== bIsNew) {
        return aIsNew ? -1 : 1;
      }

      if (!aIsNew && !bIsNew) {
        return 0;
      }

      return this.getModifiedDateTime(b) - this.getModifiedDateTime(a);
    });
  }

  private sortTinWithTopPriority(tinRows: any[]): any[] {
    return [...tinRows].sort((a: any, b: any) => {
      const aIsNew = a?.delete === 'delete';
      const bIsNew = b?.delete === 'delete';

      if (aIsNew !== bIsNew) {
        return aIsNew ? -1 : 1;
      }

      if (!aIsNew && !bIsNew) {
        return 0;
      }

      return this.getModifiedDateTime(b) - this.getModifiedDateTime(a);
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    localStorage.removeItem('isTINEditMode')
    localStorage.removeItem('isEditMode')
    localStorage.removeItem('isnewTIN')
    this.action = localStorage.getItem('Action')
    this.isRecred = this.action == 'Recred' ? true : false;
    let credentialData = localStorage.getItem('locations')
    this.locations = credentialData ? JSON.parse(credentialData) : null;
    this.locationDirectories = this.getLocationDirectories();
    this.refreshW9DocumentCache();
    const whLocations: any[] = JSON.parse((localStorage.getItem('whLocations') || '[]'))
    const isMobile = window.innerWidth <= 1024;
    if (isMobile) {
      this.getTin(1, 1000, true);
    } else {
      this.getTin(1, this.tinFetchPageSize, true);
    }
    if (this.locations?.length != 0) {
      this.locations = this.locations.map((el: any) => {
        let networkValue = el.providerNetwork;
        let isLocationFromTINSearch = el.isLocationFromTINSearch
        return {
          ...el,
          Primary : el.isPrimary ? 'Yes' : 'No',
          participating: (() => {
            // If isLocationFromTINSearch is null, use stillPracticing
            if (isLocationFromTINSearch == null) {
              return (el.stillPracticing || el.stillPracticing === null || el.stillPracticing === undefined || el.stillPracticing === '') && el.isParticipating? 'Yes' : 'No';
            }

            // Otherwise use isParticipating
            if(networkValue === 'Participating') {
              return el.isParticipating ? 'Yes' : 'No';
            } else if(!networkValue){
              return el.isParticipating ? 'Yes' : 'No';
            } else {
              return (el.stillPracticing || el.stillPracticing === null || el.stillPracticing === undefined || el.stillPracticing === '')? 'Yes' : 'No';
            }
          })(),
          delete: isLocationFromTINSearch || !el.esLocationId ? 'delete' : '',
          status: (isLocationFromTINSearch || !el.esLocationId) ? (isLocationFromTINSearch && el.esLocationId) ? 'Yes' : 'No' : 'Yes',
          documents: 'description',
          effectiveDate: this.formatEffectiveDate(el.effectiveDate) || this.formatEffectiveDate(el.startPracticingAt) || ''
        };
      });

    } else {
      this.locations = whLocations.map((el: any) => {
        return {
          ...el,
          participating: (el.providerNetwork === 'Participating') ? 'Yes' :
            (el.providerNetwork === 'Not participating') ? 'No' : '',
          delete: '',
          status: el.esLocationId ? 'Yes' : 'No',
          documents: 'description',
          effectiveDate: this.formatEffectiveDate(el.effectiveDate) || this.formatEffectiveDate(el.startPracticingAt) || ''
        };
      })
    }
    this.locations = this.locations.map((el: any) => ({
      ...el,
      address1: el.address1 || el.address || ''
    }));
    this.locations = this.sortLocationsWithTopPriority(this.locations);
    this.dataSource.data = this.locations
    this.pagedLocationData = this.locations
    this.totalRecords = this.dataSource.data.length;
    this.updatePagedLocations(0, 5);
    localStorage.removeItem('editLocationId');

    this.hasWhLocation = this.locations.some(
      (location: any) => location.esLocationId !== null && location.esLocationId !== undefined
    );
    if (this.impersonatedUser) {
      this.tableColumns = this.tableColumns.filter(coulmn => coulmn.columnId !== 'delete')
      this.tinColumns = this.tinColumns.filter(coulmn => coulmn.columnId !== 'delete')

    }
  }
  tinColumns: TableColumn[] = [
    {
      columnId: 'delete',
      columnLabel: '',
      sort: false,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent,
        data: {
          label: '',
          actionData: 'taxId'
        },
        otherParams: 'delete'
      },
      caseInsensitive: false
    },
    {
      columnId: 'IsTinFromDW',
      columnLabel: 'Existing',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'taxId',
      columnLabel: 'TIN',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'taxEntityName',
      columnLabel: 'Tax entity name',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'taxEntityAddress1',
      columnLabel: 'Address',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'taxEntityCity',
      columnLabel: 'City',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'taxEntityState',
      columnLabel: 'State',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive: false
    },
    {
      columnId: 'action',
      columnLabel: 'Action',
      sort: false,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent,
        data: {
          label: 'Upload W9',
          actionData: 'taxId'
        },
        otherParams: 'uploadW9'
      },
      caseInsensitive: false
    }
  ];

  formatEffectiveDate(dateValue: string | number): string {
    if (!dateValue) return '';

    try {
      if (typeof dateValue === 'number' || /^\d{8}$/.test(String(dateValue))) {
        const dateStr = String(dateValue);

        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);

        return `${month}/${day}/${year}`;
      }
      const date = new Date(dateValue);

      if (isNaN(date.getTime())) return '';

      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    } catch {
      return '';
    }
  }
  filterTinTable(event: any) {
    this.tinFilterText = (event.target.value || '').toLowerCase();
    this.updateTinTableView(true);
  }


  ngAfterViewChecked(): void {
    this.addDeleteIconClass()
    this.addLocationEditInlineActions();
    this.addTinW9InlineActions();
    this.addDocumentIconClass();

  }
  getLocationActionStatusClass(location: any): string {
    return this.isLocationActionIncomplete(location) ? 'action-status-red' : 'action-status-green';
  }
  getTinActionStatusClass(tinData: any): string {
    return this.hasTinW9Document(tinData) ? 'action-status-green' : 'action-status-red';
  }
  hasTinW9Document(tinData: any): boolean {
    const w9DocumentId = this.toNumberOrNull(this.getFirstNonEmpty(tinData, ['w9DocumentID', 'w9DocumentId']));
    if (w9DocumentId === null) {
      if(!this.getTinHasParticipatingLocation(tinData.taxId ?? tinData.tin)){
        return true
      }
      return false;
    }
    if (!this.hasLoadedDocuments) {
      return true;
    }
    return this.w9DocumentIds.has(w9DocumentId);
  }
  private addLocationEditInlineActions(): void {
    if (!this.tableWrapper) return;
    const actionCells: any = this.tableWrapper.nativeElement.querySelectorAll(
      '.mat-mdc-row .cdk-column-action'
    );
    actionCells.forEach((cell: HTMLElement, index: number) => {
      const row = this.pagedLocationData[index];
      if (!row) return;
      const link = cell.querySelector('a') as HTMLElement | null;
      if (!link) return;
      this.applyActionStatusClass(link, !this.isLocationActionIncomplete(row));
    });
  }
  private addTinW9InlineActions(): void {
    if (!this.tinTableWrapper) return;
    const actionCells: any = this.tinTableWrapper.nativeElement.querySelectorAll(
      '.mat-mdc-row .cdk-column-action'
    );
    actionCells.forEach((cell: HTMLElement, index: number) => {
      const row = this.tinDataSource.data[index];
      if (!row) return;
      const link = cell.querySelector('a') as HTMLElement | null;
      if (!link) return;
      const hasW9 = this.hasTinW9Document(row);
      link.innerText = hasW9 ? 'View W9' : 'Upload W9';
      link.setAttribute('aria-label', hasW9 ? 'View W9' : 'Upload W9');
      this.applyActionStatusClass(link, hasW9);
      const hasParticipatingLocation = this.getTinHasParticipatingLocation(
        row.taxId ?? row.tin
      );

      if (hasParticipatingLocation) {
        link.innerText =  hasW9 ? 'View W9' : 'Upload W9';
        link.setAttribute('aria-label', hasW9 ? 'View W9' : 'Upload W9');
        this.applyActionStatusClass(link, hasW9);
        link.style.display = '';
      } else {
        link.innerText = '';
        link.style.display = 'none';
      }
      const existingButton = cell.querySelector('.tin-w9-delete-inline');
      if (existingButton) {
        existingButton.remove();
      }
      if (hasParticipatingLocation && hasW9) {
        const deleteButton = this.renderer.createElement('button');
        this.renderer.addClass(deleteButton, 'tin-w9-delete-inline');
        this.renderer.setAttribute(deleteButton, 'type', 'button');
        this.renderer.setAttribute(deleteButton, 'aria-label', 'Delete W9');
        this.renderer.setProperty(deleteButton, 'textContent', '×');
        this.renderer.listen(deleteButton, 'click', (event: MouseEvent) => {
          event.preventDefault();
          event.stopPropagation();
          this.w9DeleteAlertPopupCall(row);
        });
        this.renderer.appendChild(cell, deleteButton);
      }
    });
  }
    getTinHasParticipatingLocation(tin:any): boolean {
        const locations = JSON.parse(localStorage.getItem('locations') || '[]');
        const tinHasparticipatingLoc = locations.some((loc: any) => (loc.taxId ? loc.taxId : loc.tin) === tin && loc.isParticipating === true);
        return tinHasparticipatingLoc;
  }
  private applyActionStatusClass(link: HTMLElement, isComplete: boolean): void {
    link.classList.remove('action-status-red', 'action-status-green');
    link.classList.add(isComplete ? 'action-status-green' : 'action-status-red');
  }
  private isLocationActionIncomplete(location: any): boolean {
    if (!location) {
      return true;
    }
    const officeTypeId = location?.officeTypeID ?? location?.officeTypeId;
    const endedPracticingAt = location?.endedPracticingAt ?? location?.endDate ?? location?.endedDate;
    const stillPracticing = this.getBooleanValue(location?.stillPracticing);
    return (
      this.isValueEmpty(officeTypeId) ||
      this.isValueEmpty(location?.voicePhone) ||
      this.isValueEmpty(location?.email ?? location?.locationEmail) ||
      (stillPracticing === false && this.isValueEmpty(endedPracticingAt)) ||
      this.isCorporateAuthoritySignatureMissing(location) ||
      this.hasIncompletePrimaryLocationDirectory(location) ||
      this.isLocationTinW9Missing(location)
    );
  }
  private isCorporateAuthoritySignatureMissing(location: any): boolean {
    if (this.getBooleanValue(location?.isParticipating) !== true) {
      return false;
    }

    const isLocationFromTinSearch = this.getBooleanValue(location?.isLocationFromTINSearch) === true;
    const isNewLocation = !location?.esLocationId && !isLocationFromTinSearch;
    const isNewlyParticipatingExistingLocation =
      !!location?.esLocationId && !this.isExistingParticipatingLocation(location);
    const requiresCorporateAuthorityForm =
      isNewLocation || isNewlyParticipatingExistingLocation || isLocationFromTinSearch;

    if (!requiresCorporateAuthorityForm && this.getBooleanValue(location?.isCorpAuthResignRequired) !== true) {
      return false;
    }

    const documentId = location?.dcaDocumentId;
    if (!documentId) {
      return true;
    }

    const documents = JSON.parse(localStorage.getItem('documents') || '[]');
    const corporateAuthorityDocument = Array.isArray(documents)
      ? documents.find((document: any) => `${document?.documentId}` === `${documentId}`)
      : null;

    return this.getBooleanValue(corporateAuthorityDocument?.isSigned) !== true;
  }
  private isExistingParticipatingLocation(location: any): boolean {
    let network = location?.providerNetwork;
    if (!network && location?.esLocationId) {
      const whLocations = JSON.parse(localStorage.getItem('whLocations') || '[]');
      const match = Array.isArray(whLocations)
        ? whLocations.find((wh: any) => wh?.esLocationId === location.esLocationId)
        : null;
      network = match?.providerNetwork;
    }

    return network === 'Participating';
  }
  private hasIncompletePrimaryLocationDirectory(location: any): boolean {
    const isPrimaryLocation = this.getBooleanValue(location?.isPrimary) === true || `${location?.Primary || ''}`.toLowerCase() === 'yes';
    if (!isPrimaryLocation) {
      return false;
    }

    const directory = this.findLocationDirectory(location);
    if (!directory) {
      return true;
    }

    const hasMissingRadio = this.directoryRequiredQuestions.some((key: string) => this.isValueEmpty(directory[key]));
    if (hasMissingRadio) {
      return true;
    }

    if (directory.hasEmergencyPhoneNumber === true) {
      const phonePattern = /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/;
      if (this.isValueEmpty(directory.emergencyPhoneNumber) || !phonePattern.test(directory.emergencyPhoneNumber)) {
        return true;
      }
    }

    return false;
  }
  private isLocationTinW9Missing(location: any): boolean {
    const matchingTinRows = this.getTinRowsForLocation(location);
    if (matchingTinRows.length === 0) {
      return false;
    }
    return !matchingTinRows.some((tinRow: any) => this.hasTinW9Document(tinRow));
  }
  private getTinRowsForLocation(location: any): any[] {
    const locationTin = this.normalizeTinIdentifier(this.getFirstNonEmpty(location, ['tin', 'taxId']));
    if (!locationTin) {
      return [];
    }
    const currentTinRows = Array.isArray(this.tinData)
      ? this.tinData.filter(
        (tin: any) => this.normalizeTinIdentifier(tin?.taxId ?? tin?.tin) === locationTin
      )
      : [];
    if (currentTinRows.length > 0) {
      return currentTinRows;
    }

    const storedTinRows = JSON.parse(localStorage.getItem('TINDetails') || '[]');
    if (!Array.isArray(storedTinRows)) {
      return [];
    }
    return storedTinRows.filter(
      (tin: any) => this.normalizeTinIdentifier(tin?.taxId ?? tin?.tin) === locationTin
    );
  }
  private findLocationDirectory(location: any): any {
    const locationIds = [location?.locationId, location?.esLocationId]
      .filter((id: any) => !this.isValueEmpty(id))
      .map((id: any) => `${id}`);
    return this.locationDirectories.find((directory: any) => locationIds.includes(`${directory?.locationId}`));
  }
  private getLocationDirectories(): any[] {
    const directoryData = localStorage.getItem('locationDirectories');
    return directoryData ? JSON.parse(directoryData) : [];
  }
  private refreshW9DocumentCache(): void {
    const storedDocuments = localStorage.getItem('documents');
    this.hasLoadedDocuments = storedDocuments !== null;
    const documents = storedDocuments ? JSON.parse(storedDocuments) : [];
    const parsedDocuments = Array.isArray(documents) ? documents : [];
    const nextW9DocumentIds = new Set<number>();

    parsedDocuments.forEach((document: any) => {
      const subCategoryId = this.toNumberOrNull(document?.subCategoryId);
      const documentId = this.toNumberOrNull(document?.documentId);
      if (subCategoryId === DocumentSubCategory.W9Form && documentId !== null) {
        nextW9DocumentIds.add(documentId);
      }
    });

    this.w9DocumentIds = nextW9DocumentIds;
  }
  private isValueEmpty(value: any): boolean {
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
  }
  private hasValue(value: any): boolean {
    return value !== null && value !== undefined && `${value}` !== '';
  }
  private idsMatch(left: any, right: any): boolean {
    return this.hasValue(left) && this.hasValue(right) && `${left}` === `${right}`;
  }
  private getBooleanValue(value: any): boolean | null {
    if (value === true || value === 'yes' || value === 'Yes' || value === 'true' || value === 1 || value === '1') {
      return true;
    }
    if (value === false || value === 'no' || value === 'No' || value === 'false' || value === 0 || value === '0') {
      return false;
    }
    return null;
  }
  private getFirstNonEmpty(source: any, keys: string[]): any {
    for (const key of keys) {
      const value = source?.[key];
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return null;
  }
  private normalizeIdentifier(value: any): string {
    return this.hasValue(value) ? `${value}`.trim() : '';
  }
  private normalizeTinIdentifier(value: any): string {
    const normalizedValue = this.normalizeIdentifier(value);
    if (!normalizedValue) {
      return '';
    }
    const digitsOnly = normalizedValue.replace(/[^0-9]/g, '');
    return digitsOnly || normalizedValue;
  }
  private getTinRecordLocationIds(source: any): string[] {
    const ids = [source?.locationId, source?.esLocationId, source?.locationLookupId]
      .map((id: any) => this.normalizeIdentifier(id))
      .filter((id: string) => !!id);
    return [...new Set(ids)];
  }
  private toNumberOrNull(value: any): number | null {
    if (!this.hasValue(value)) {
      return null;
    }
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? null : numericValue;
  }
  private isSameTinRow(candidate: any, target: any): boolean {
    const candidateTin = this.normalizeTinIdentifier(candidate?.taxId ?? candidate?.tin);
    const targetTin = this.normalizeTinIdentifier(target?.taxId ?? target?.tin);
    if (!candidateTin || !targetTin || candidateTin !== targetTin) {
      return false;
    }
    const candidateLocationIds = this.getTinRecordLocationIds(candidate);
    const targetLocationIds = this.getTinRecordLocationIds(target);
    if (!candidateLocationIds.length || !targetLocationIds.length) {
      return true;
    }
    return candidateLocationIds.some((id: string) => targetLocationIds.includes(id));
  }
  private resolveTinLocationId(tinData: any): number | null {
    const directLocationId = this.toNumberOrNull(this.getFirstNonEmpty(tinData, ['locationId']));
    if (directLocationId !== null) {
      return directLocationId;
    }

    const targetLocationIds = this.getTinRecordLocationIds(tinData);
    const allLocations = Array.isArray(this.locations) && this.locations.length > 0
      ? this.locations
      : JSON.parse(localStorage.getItem('locations') || '[]');
    if (!Array.isArray(allLocations)) {
      return null;
    }

    if (targetLocationIds.length > 0) {
      const matchById = allLocations.find((location: any) => {
        const locationIds = this.getTinRecordLocationIds(location);
        return locationIds.some((id: string) => targetLocationIds.includes(id));
      });
      const matchedLocationId = this.toNumberOrNull(matchById?.locationId);
      if (matchedLocationId !== null) {
        return matchedLocationId;
      }
    }

    const targetTin = this.normalizeTinIdentifier(this.getFirstNonEmpty(tinData, ['taxId', 'tin']));
    if (!targetTin) {
      return null;
    }
    const matchByTin = allLocations.find((location: any) =>
      this.normalizeTinIdentifier(location?.tin) === targetTin &&
      this.toNumberOrNull(location?.locationId) !== null
    );
    return this.toNumberOrNull(matchByTin?.locationId);
  }
  private addDocumentIconClass(): void {
    if (this.tableWrapper) {
      const documentLinks: any = this.tableWrapper.nativeElement.querySelectorAll(
        'a[aria-label="description"]'
      );
      documentLinks.forEach((link: HTMLElement) => {
        if (!link.classList.contains('material-icons')) {
          this.renderer.addClass(link, 'material-icons');
          this.renderer.addClass(link, 'docanchor');
          link.innerHTML = `<mat-icon class="landingIcons" title="View documents">description</mat-icon>`
        }
      });
    }
  }
  ngAfterViewInit() {
  }
  filterTable(event: any) {
    let input = event.target.value;
    if (!this.locations) return;
    const filteredLocations = this.locations.filter((location: any) =>
      location.name.toLowerCase().includes(input.toLowerCase()) ||
      location.address1.toLowerCase().includes(input.toLowerCase()) ||
      location.city.toLowerCase().includes(input.toLowerCase()) ||
      location.state.toLowerCase().includes(input.toLowerCase()) ||
      location.participating.toLowerCase().includes(input.toLowerCase())
    );
    this.dataSource.data = filteredLocations;
    this.totalRecords = this.dataSource.data.length;
    this.paginator?.firstPage();
    this.updatePagedLocations(0, this.currentPageSize);
  }

  onTableClick(event: any) {

    if (event?.otherParams == 'delete') {
      let id = event.data
      this.locationDeleteAlertPopupCall(id, true)
    } else if (event?.otherParams?.actionKey == 'documents') {
      this.openLocationDocuments(event.data);
    } else {
      const selectedLocationId = event?.data;
      const selectedEsLocationId = event?.row?.esLocationId;
      const selectedRecord = (Array.isArray(this.locations) ? this.locations : []).find(
        (location: any) =>
          this.idsMatch(location?.locationId, selectedLocationId) ||
          this.idsMatch(location?.esLocationId, selectedEsLocationId)
      );
      if (!selectedRecord) {
        return;
      }
      const editLocationId = this.hasValue(selectedLocationId) ? selectedLocationId : selectedEsLocationId;
      if (!this.hasValue(editLocationId)) {
        return;
      }
      const selectedLocationRecord = this.hasValue(selectedEsLocationId)
        ? { ...selectedRecord, esLocationId: selectedEsLocationId }
        : { ...selectedRecord };
      sessionStorage.setItem("selectedLocationRecord", JSON.stringify(selectedLocationRecord))
      localStorage.setItem('editLocationId', `${editLocationId}`);
      this.router.navigate(['/credentialing/locations/add']);
    }
  }
  openLocationDocuments(locationId: any) {
    this.dialog.open(DocumentPreviewComponent, {
      width: '90%',
      maxHeight: '90vh',
      panelClass: 'document-dialog',
      data: { locationId: locationId }
    });
  }
  onTinTableClick(event: any) {
    if (event.otherParams == 'delete') {
      const taxId = event?.data ?? event?.row?.taxId;
      if (!taxId) {
        return;
      }
      this.tinDeleteAlertPopupCall(taxId);
      return;
    }
    if (event.otherParams == 'uploadW9') {
      const tinData = event.row ?? this.tinData.find((tin: any) => this.idsMatch(tin?.taxId, event?.data));
      if (!tinData) {
        return;
      }
      if (this.hasTinW9Document(tinData)) {
        this.viewW9DocumentForTin(tinData);
        return;
      }
      this.selectedTinForW9Upload = tinData;
      this.w9Uploader?.openPicker();
    }
    if (event.otherParams == 'deleteW9') {
      const tinData = event.row ?? this.tinData.find((tin: any) => this.idsMatch(tin?.taxId, event?.data));
      if (!tinData) {
        return;
      }
      this.w9DeleteAlertPopupCall(tinData);
    }
  }
  async onW9FileSelected(file: File) {
    if (!file || !this.selectedTinForW9Upload) {
      return;
    }

    const ext = file.name.split('.').pop()?.toLowerCase();
    if (ext !== 'pdf') {
      this.dialog.open(PopupComponent, {
        disableClose: true,
        data: { headerMessage: 'Alert', message: 'Only PDF is accepted.', isPTESaved: true },
        width: '550px',
        backdropClass: '',
        hasBackdrop: true,
      });
      this.selectedTinForW9Upload = null;
      return;
    }

    this.loader.show();
    try {
      const credentialPayload = JSON.parse(localStorage.getItem('getCredentialpayload') || '{}');
      const npi = credentialPayload?.npi ?? 'unknown';
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const filename = `${year}${month}${day}_${npi}_${uuidv4()}`;
      const response: any = await this.uploadW9Document(file, filename);

      const tinPayload = this.buildTinUpdatePayload(this.selectedTinForW9Upload, response.documentId);
      await new Promise<void>((resolve, reject) => {
        this.service.saveLocationPayeeTax({ taxEntities: tinPayload }).subscribe({
          next: () => resolve(),
          error: (err: any) => reject(err)
        });
      });

      this.updateTinAfterW9Upload(this.selectedTinForW9Upload, response.documentId);
    } catch (err) {
      this.service.logError("APIFailed", "FileLocationComponent - saveDocument, Method:onW9FileSelected", this.router.url.split('?')[0], err).subscribe();
      this.service.deleteLocationFailedPopupCall(false, 'saveTin');
    } finally {
      this.loader.hide();
      this.selectedTinForW9Upload = null;
    }
  }
  private async uploadW9Document(file: File, filename: string) {
    const loginUserId = localStorage.getItem("loggedUserId");
    const params = {
      credentialingEventId: localStorage.getItem('credentialingEventId'),
      categoryId: DocumentCategory.Location,
      subCategoryId: DocumentSubCategory.W9Form,
      fileName: filename,
      isSigned: true,
      userId: loginUserId || -1
    };
    const response = await this.dentalCredentialingService.saveDocument(file, params);
    const documents = JSON.parse(localStorage.getItem('documents') || '[]');
    if (this.selectedTinForW9Upload?.w9DocumentID) {
      const previousDocIndex = documents.findIndex(
        (item: any) => item.documentId === this.selectedTinForW9Upload.w9DocumentID
      );
      if (previousDocIndex !== -1) {
        documents.splice(previousDocIndex, 1);
      }
    }
    documents.push({
      credentialingEventId: localStorage.getItem('credentialingEventId'),
      categoryId: DocumentCategory.Location,
      category: "Location",
      subCategoryId: DocumentSubCategory.W9Form,
      subcategory: DocumentSubCategoryName[DocumentSubCategory.W9Form],
      fileName: filename,
      isSigned: true,
      userId: loginUserId || -1,
      documentId: response.documentId
    });
    localStorage.setItem('documents', JSON.stringify(documents));
    this.refreshW9DocumentCache();
    return response;
  }
  private buildTinUpdatePayload(tinData: any, w9DocumentId: number | null) {
    const loginUserId = localStorage.getItem("loggedUserId");
    const eventId = localStorage.getItem('credentialingEventId');
    const taxId = this.getFirstNonEmpty(tinData, ['taxId', 'tin']) || '';
    const resolvedLocationId = this.resolveTinLocationId(tinData);
    const taxTypeId = this.toNumberOrNull(this.getFirstNonEmpty(tinData, ['taxTypeId', 'taxIDTypeID']));
    const serviceLocationSameAsPayee = this.getBooleanValue(this.getFirstNonEmpty(tinData, ['serviceLocationSameAsPayee'])) === true;
    const isTinFromDW = this.getBooleanValue(this.getFirstNonEmpty(tinData, ['isTinFromDW', 'IsTinFromDW'])) === true;

    return {
      taxEntityId: this.toNumberOrNull(this.getFirstNonEmpty(tinData, ['taxEntityId'])),
      taxTypeId: taxTypeId,
      taxId: taxId,
      taxEntityName: this.getFirstNonEmpty(tinData, ['taxEntityName']) || '',
      taxEntityAddress1: this.getFirstNonEmpty(tinData, ['taxEntityAddress1', 'address1']) || '',
      taxEntityAddress2: this.getFirstNonEmpty(tinData, ['taxEntityAddress2', 'address2']) || '',
      taxEntityCity: this.getFirstNonEmpty(tinData, ['taxEntityCity', 'city']) || '',
      taxEntityState: this.getFirstNonEmpty(tinData, ['taxEntityState', 'state']) || '',
      taxEntityZip: this.getFirstNonEmpty(tinData, ['taxEntityZip', 'zip']) || '',
      taxEntityEmail: this.getFirstNonEmpty(tinData, ['taxEntityEmail', 'payeeEmail', 'email']) || '',
      taxEntityVoicePhone: this.getFirstNonEmpty(tinData, ['taxEntityVoicePhone', 'payeeVoicePhone', 'payeePhone', 'voicePhone']) || '',
      effectiveDate: this.getFirstNonEmpty(tinData, ['taxEntityEffectiveDate', 'effectiveDate']) || null,
      esPayeeId: this.toNumberOrNull(this.getFirstNonEmpty(tinData, ['esPayeeId', 'payeeId'])),
      locationId: resolvedLocationId,
      payeeName: this.getFirstNonEmpty(tinData, ['payeeName']) || '',
      payeeAddressLine1: this.getFirstNonEmpty(tinData, ['payeeAddressLine1', 'payeeAddress1', 'payeeAddress']) || '',
      payeeAddressLine2: this.getFirstNonEmpty(tinData, ['payeeAddressLine2', 'payeeAddress2']) || '',
      payeeCity: this.getFirstNonEmpty(tinData, ['payeeCity']) || '',
      payeeState: this.getFirstNonEmpty(tinData, ['payeeState']) || '',
      payeeZip: this.getFirstNonEmpty(tinData, ['payeeZip']) || '',
      payeeEmail: this.getFirstNonEmpty(tinData, ['payeeEmail']) || '',
      payeeVoicePhone: this.getFirstNonEmpty(tinData, ['payeeVoicePhone', 'payeePhone']) || '',
      payeeNPI: this.getFirstNonEmpty(tinData, ['payeeNPI', 'npi2']) || '',
      w9DocumentID: w9DocumentId == null ? null : Number(w9DocumentId),
      serviceLocationSameAsPayee: serviceLocationSameAsPayee,
      activeFlg: true,
      userId: loginUserId ? Number(loginUserId) : 0,
      isTinFromDW: isTinFromDW,
      credentialingEventId: eventId ? Number(eventId) : 0
    };
  }
  private updateTinAfterW9Upload(tinData: any, w9DocumentId: number | null) {
    const updateRecord = (item: any) =>
      (this.isSameTinRow(item, tinData) ? {
        ...item,
        w9DocumentID: w9DocumentId
      } : item);

    this.tinData = this.tinData.map(updateRecord);
    this.originalTinData = this.originalTinData.map(updateRecord);
    localStorage.setItem('TINDetails', JSON.stringify(this.tinData));
    this.updateTinTableView();
  }
  viewW9DocumentForTin(tinData: any) {
    const documentId = Number(tinData?.w9DocumentID ?? 0);
    const documents = JSON.parse(localStorage.getItem('documents') || '[]');
    const w9Document = documents.find((doc: any) => Number(doc.documentId) === documentId);
    if (!w9Document?.fileName) {
      this.dialog.open(W9AlertComponent, {
        disableClose: true,
        data: { message: "Unable to locate W9 document details for viewing.", deleted: true },
        width: '550px',
        backdropClass: '',
        hasBackdrop: true,
      });
      return;
    }
    this.loader.show();
    this.dentalCredentialingService.viewAzureDocument(w9Document.fileName).subscribe({
      next: (response: any) => {
        const blob: Blob = response.body;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${w9Document.fileName}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.loader.hide();
      },
      error: (err: any) => {
        this.loader.hide();
        this.service.logError("APIFailed", "FileLocationComponent - viewAzureDocument, Method:viewW9DocumentForTin", this.router.url.split('?')[0], err).subscribe();
        this.dialog.open(W9AlertComponent, {
          disableClose: true,
          data: { message: "Failed to view W9 document. Please try again.", deleted: true },
          width: '550px',
          backdropClass: '',
          hasBackdrop: true,
        });
      }
    });
  }
  w9DeleteAlertPopupCall(tinData: any) {
    const documentId = Number(tinData?.w9DocumentID ?? 0);
    if (!documentId) {
      this.dialog.open(W9AlertComponent, {
        disableClose: true,
        data: { message: "No W9 document found for this TIN.", deleted: true },
        width: '550px',
        backdropClass: '',
        hasBackdrop: true,
      });
      return;
    }

    const dialogRef = this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: "Please confirm you are about to delete this W9 document?", deleted: false },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == true) {
        this.deleteW9DocumentForTin(tinData);
      }
    });
  }
  deleteW9DocumentForTin(tinData: any) {
    const documentId = Number(tinData?.w9DocumentID ?? 0);
    const documents = JSON.parse(localStorage.getItem('documents') || '[]');
    const w9Document = documents.find((doc: any) => Number(doc.documentId) === documentId);
    if (!w9Document?.fileName) {
      this.dialog.open(W9AlertComponent, {
        disableClose: true,
        data: { message: "Unable to locate W9 document details for deletion.", deleted: true },
        width: '550px',
        backdropClass: '',
        hasBackdrop: true,
      });
      return;
    }

    this.loader.show();
    const loginUserId = localStorage.getItem("loggedUserId");
    const credentialingEventId = localStorage.getItem('credentialingEventId');
    const requestParams = {
      credentialingEventID: Number(credentialingEventId),
      fileName: w9Document.fileName,
      modifiedUserID: loginUserId ? Number(loginUserId) : -1
    };

    this.dentalCredentialingService.deleteDocument(requestParams).subscribe({
      next: () => {
        const payload = this.buildTinUpdatePayload(tinData, null);
        this.service.saveLocationPayeeTax({ taxEntities: payload }).subscribe({
          next: () => {
            const updatedDocuments = documents.filter((doc: any) => Number(doc.documentId) !== documentId);
            localStorage.setItem('documents', JSON.stringify(updatedDocuments));
            this.refreshW9DocumentCache();
            this.updateTinAfterW9Upload(tinData, null);
            this.loader.hide();
            this.dialog.open(W9AlertComponent, {
              disableClose: true,
              data: { message: "W9 document deleted successfully.", deleted: true },
              width: '550px',
              backdropClass: '',
              hasBackdrop: true,
            });
          },
          error: (err: any) => {
            this.loader.hide();
            this.service.logError("APIFailed", "FileLocationComponent - saveLocationPayeeTax, Method:deleteW9DocumentForTin", this.router.url.split('?')[0], err).subscribe();
            this.dialog.open(W9AlertComponent, {
              disableClose: true,
              data: { message: "Failed to update TIN after deleting W9. Please try again.", deleted: true },
              width: '550px',
              backdropClass: '',
              hasBackdrop: true,
            });
          }
        });
      },
      error: (err: any) => {
        this.loader.hide();
        this.service.logError("APIFailed", "FileLocationComponent - deleteDocument, Method:deleteW9DocumentForTin", this.router.url.split('?')[0], err).subscribe();
        this.dialog.open(W9AlertComponent, {
          disableClose: true,
          data: { message: "Failed to delete W9 document. Please try again.", deleted: true },
          width: '550px',
          backdropClass: '',
          hasBackdrop: true,
        });
      }
    });
  }

  tinDeleteAlertPopupCall(taxId: any) {
    this.loader.hide();
    const alertMessage = "Please confirm you are about to delete this TIN and its associated newly added locations?";
    const dialogRef = this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: alertMessage, deleted: false },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == true) {
        this.deleteTinAndLinkedLocations(taxId);
      }
    });
  }

  deleteTinAndLinkedLocations(taxId: any) {
    this.loader.show();
    const loginUserId = localStorage.getItem("loggedUserId");
    const eventId = localStorage.getItem('credentialingEventId');
    const normalizedTaxId = this.normalizeTinIdentifier(taxId);
    const tinToDelete = this.tinData.find((t: any) =>
      this.normalizeTinIdentifier(t?.taxId ?? t?.tin) === normalizedTaxId
    );
    if (!tinToDelete) {
      this.loader.hide();
      this.service.deleteLocationFailedPopupCall(true, 'tin')
      return;
    }
    const tinPayload = {
      taxEntityId: this.toNumberOrNull(tinToDelete?.taxEntityId),
      taxTypeId: this.toNumberOrNull(tinToDelete?.taxTypeId),
      taxId: tinToDelete?.taxId ?? tinToDelete?.tin ?? taxId,
      userId: loginUserId ? Number(loginUserId) : 0,
      credentialingEventId: eventId ? Number(eventId) : 0,
      activeFlg: false
    };
    this.service.saveLocationPayeeTax({ taxEntities: tinPayload }).subscribe({
      next: () => {
        if (normalizedTaxId && normalizedTaxId === this.normalizeTinIdentifier(localStorage.getItem('latestCreatedTinTaxId'))) {
          localStorage.removeItem('latestCreatedTinTaxId');
        }
        const updatedTinTotalRecords = Math.max(0, this.tinTotalRecords - 1);
        const maxTinPageIndex = Math.max(0, Math.ceil(updatedTinTotalRecords / this.currentTinPageSize) - 1);
        const nextTinPageIndex = Math.min(this.currentTinPageIndex, maxTinPageIndex);
        this.currentTinPageIndex = nextTinPageIndex;
        this.tinData = this.tinData.filter((t: any) =>
          this.normalizeTinIdentifier(t?.taxId ?? t?.tin) !== normalizedTaxId
        );
        this.tinDataSource.data = this.tinData;
        this.originalTinData = this.tinData;
        localStorage.setItem('TINDetails', JSON.stringify(this.tinData));
        this.tinTotalRecords = updatedTinTotalRecords;
        this.locations = this.locations.map((el: any) => ({
          ...el,
          address1: el.address1 || el.address || ''
        }));
        this.dataSource.data = []
        this.locations = this.locations.filter((loc: any) =>
          this.normalizeTinIdentifier(loc?.tin) !== normalizedTaxId
        );
        localStorage.setItem('locations', JSON.stringify(this.locations));
        this.dataSource.data = this.locations;
        this.pagedLocationData = this.locations
        this.totalRecords = this.dataSource.data.length;
        this.getTin(1, this.tinFetchPageSize, false);
        this.cdr.detectChanges();
        this.loader.hide();
        this.showTinDeleteSuccessAlert();
      },
      error: (err: any) => {
        this.loader.hide();
        if (err) {
          this.service.deleteLocationFailedPopupCall(true, 'tin')
        }
        this.service.logError("APIFailed", "FileLocationComponent - saveLocationPayeeTax, Method:deleteTinAndLinkedLocations", this.router.url.split('?')[0], err).subscribe();
      }
    });
  }

  showTinDeleteSuccessAlert() {
    this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: "TIN and associated locations deleted successfully.", deleted: true },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
  }
  onAddLocation() {
    localStorage.removeItem("SearchedTin")
    sessionStorage.removeItem("selectedLocationRecord")
    localStorage.removeItem('SearchTINResponse');
    localStorage.removeItem('editLocationId');
    localStorage.removeItem('isCorpAuthDeleteRequired');
    this.router.navigate(['credentialing/search-tin'])
  }

  onEdit(id: number) {
  }

  onBack() {
    this.router.navigate(['/credentialing/attestations']);
  }

  onNext() {
    this.router.navigate(['/credentialing/sign-documents']);
  }

  onCancel() {
    this.router.navigate(['/landing']);
  }
  private addDeleteIconClass(): void {
    this.applyDeleteIconClass(this.tableWrapper, 'Delete location');
    this.applyDeleteIconClass(this.tinTableWrapper, 'Delete TIN');
  }
  private applyDeleteIconClass(wrapper: ElementRef<HTMLElement> | undefined, title: string): void {
    if (!wrapper) return;
    const deleteLinks: any = wrapper.nativeElement.querySelectorAll('a[aria-label="delete"]');
    deleteLinks.forEach((link: HTMLElement) => {
      if (!link.classList.contains('material-icons')) {
        this.renderer.addClass(link, 'material-icons');
        this.renderer.addClass(link, 'docanchor');
        link.innerHTML = `<mat-icon class="landingIcons" title="${title}">delete</mat-icon>`;
      }
    });
  }
  private updatePagedLocations(pageIndex: number = this.currentPageIndex, pageSize: number = this.currentPageSize) {
    this.currentPageIndex = pageIndex;
    this.currentPageSize = pageSize;
    const start = pageIndex * pageSize;
    this.pagedLocationData = this.dataSource.data.slice(start, start + pageSize);
  }
  onPageChange(event: any) {
    this.updatePagedLocations(event.pageIndex, event.pageSize);
  }
  locationDeleteAlertPopupCall(id: number, isDeleteAlert?: any) {
    this.loader.hide();
    let alertMessage: any
    if (isDeleteAlert) {
      alertMessage = "Please confirm you are about to delete this location?"
    } else {
      alertMessage = "The location is deleted successfully";
    }
    let dialogRef = this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: alertMessage, deleted: !isDeleteAlert ? true : false },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == true && isDeleteAlert) {
        this.deleteLocation(id)
      }
    });
  }
  onTinPageChange(event: any) {
    this.currentTinPageIndex = event.pageIndex;
    this.currentTinPageSize = event.pageSize;
    this.updateTinTableView();
  }
  deleteLocation(id: number) {
    this.loader.show()
    const loginUserId = localStorage.getItem("loggedUserId");
    const eventId = localStorage.getItem('credentialingEventId');
    const locationToDelete = this.locations.find((item: any) =>
      this.idsMatch(item?.locationId, id)
    );
    if (!locationToDelete) {
      this.loader.hide();
      this.service.deleteLocationFailedPopupCall(true, 'location');
      return;
    }
    const locationIdToDelete = this.toNumberOrNull(locationToDelete?.locationId);
    if (locationIdToDelete == null) {
      this.loader.hide();
      this.service.deleteLocationFailedPopupCall(true, 'location');
      return;
    }
    const deletedLocationTin = this.normalizeTinIdentifier(locationToDelete?.tin ?? null);
    const payloadArray = [{
      locationId: locationIdToDelete,
      name: locationToDelete.name,
      address: locationToDelete.address1 ?? locationToDelete.address ?? '',
      city: locationToDelete.city,
      state: locationToDelete.state,
      zip: locationToDelete.zip,
      tin: locationToDelete.tin ?? "",
      isPrimary: locationToDelete.isPrimary,
      userId: loginUserId ? Number(loginUserId) : 0,
      esLocationId: locationToDelete.esLocationId ?? null,
      credentialingEventId: locationToDelete.credentialingEventId ?? eventId,
      activeFlg: 0,
      stillPracticing: locationToDelete.stillPracticing ?? null,
      isParticipating: locationToDelete.isParticipating ?? null,
      email: locationToDelete.email ?? null,
    }];
    this.service.saveLocationPayeeTax({ locations: payloadArray }).subscribe({
      next: (response: any) => {
        const responseLocations = this.getSavedLocationRecords(response);
        const stillExistsInResponse = responseLocations.some((item: any) =>
          this.idsMatch(item?.locationId, id)
        );
        if (stillExistsInResponse) {
          this.loader.hide()
          this.service.deleteLocationFailedPopupCall(true, 'location')
          return;
        }

        if (String(id ?? '') === localStorage.getItem('latestCreatedLocationId')) {
          localStorage.removeItem('latestCreatedLocationId');
        }
        const deletedLocationIndex = this.locations.findIndex((item: any) =>
          this.idsMatch(item?.locationId, locationToDelete?.locationId) &&
          this.idsMatch(item?.esLocationId, locationToDelete?.esLocationId) &&
          this.normalizeTinIdentifier(item?.tin) === this.normalizeTinIdentifier(locationToDelete?.tin)
        );
        if (deletedLocationIndex !== -1) {
          this.locations.splice(deletedLocationIndex, 1);
        } else {
          const fallbackDeleteIndex = this.locations.findIndex((item: any) =>
            this.idsMatch(item?.locationId, id)
          );
          if (fallbackDeleteIndex !== -1) {
            this.locations.splice(fallbackDeleteIndex, 1);
          }
        }

        const isTinOrphanedAfterLocationDelete = !!deletedLocationTin &&
          !this.locations.some((item: any) => this.normalizeTinIdentifier(item?.tin) === deletedLocationTin);
        const expectedTinTotalRecords = isTinOrphanedAfterLocationDelete
          ? Math.max(0, this.tinTotalRecords - 1)
          : this.tinTotalRecords;
        const maxTinPageIndex = Math.max(0, Math.ceil(expectedTinTotalRecords / this.currentTinPageSize) - 1);
        this.currentTinPageIndex = Math.min(this.currentTinPageIndex, maxTinPageIndex);
        this.tinTotalRecords = expectedTinTotalRecords;
        this.getTin(1, this.tinFetchPageSize, false);

        this.loader.hide()
        this.locationDeleteAlertPopupCall(id, false)
        this.locations = this.locations.map((el: any) => ({
          ...el,
          address1: el.address1 || el.address || ''
        }));
        this.locations = this.sortLocationsWithTopPriority(this.locations);
        this.dataSource.data = this.locations;
        this.pagedLocationData = this.locations
        this.totalRecords = this.dataSource.data.length;
        localStorage.setItem('locations', JSON.stringify(this.locations))
        const maxPageIndex = Math.max(0, Math.ceil(this.totalRecords / this.currentPageSize) - 1);
        const pageIndex = Math.min(this.currentPageIndex, maxPageIndex);
        this.updatePagedLocations(pageIndex, this.currentPageSize);
      }, error: (err: any) => {
        this.loader.hide()
        if (err) {
          this.service.deleteLocationFailedPopupCall(true, 'location')
        }
        this.service.logError("APIFailed", "FileLocationComponent - saveLocationPayeeTax, Method:onTableClick", this.router.url.split('?')[0], err).subscribe();
      }
    })
  }
  private getSavedLocationRecords(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    const collections = [
      response?.locations,
      response?.saveLocationResponse,
      response?.locationResponse,
      response?.data?.locations,
      response?.data?.saveLocationResponse,
      response?.data?.locationResponse
    ];

    for (const collection of collections) {
      if (Array.isArray(collection)) {
        return collection;
      }
    }

    if (response?.locationId != null) {
      return [response];
    }
    if (response?.data?.locationId != null) {
      return [response.data];
    }

    return [];
  }

  private getTaxEntityRowsFromResponse(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (Array.isArray(response?.data)) {
      return response.data;
    }
    return [];
  }

  private buildTinDetailsFromTaxEntities(taxEntityRows: any[]): any[] {
    if (!Array.isArray(taxEntityRows)) {
      return [];
    }

    return taxEntityRows.flatMap((taxEntity: any) => {
      const locations = Array.isArray(taxEntity?.locations) ? taxEntity.locations : [];
      const payees = Array.isArray(taxEntity?.payees) ? taxEntity.payees : [];

      if (!payees.length) {
        return [{ ...taxEntity }];
      }

      return payees.map((payee: any) => {
        const linkedLocation = locations.find((location: any) => `${location?.locationId ?? ''}` === `${payee?.locationId ?? ''}`) || {};
        return {
          ...taxEntity,
          ...linkedLocation,
          ...payee,
          locationId: payee?.locationId ?? linkedLocation?.locationId ?? null,
          esLocationId: linkedLocation?.esLocationId ?? null,
          payeeAddressLine1: payee?.payeeAddressLine1 ?? payee?.payeeAddress1 ?? '',
          payeeAddressLine2: payee?.payeeAddressLine2 ?? payee?.payeeAddress2 ?? '',
          payeeLocation: payee?.payeeLocation ?? payee?.payeeAddress1 ?? '',
          serviceLocationChecked: payee?.serviceLocationSameAsPayee
        };
      });
    });
  }

  getTin(pageNumber: number = 1, pageSize: number = this.tinFetchPageSize, resetToFirstPage: boolean = false) {
    this.loader.show();
    const loginUserId = localStorage.getItem("loggedUserId");
    const loggedUserDetails = JSON.parse(localStorage.getItem("loggedUserDetails") || '{}');
    const credentialingEventId = localStorage.getItem("credentialingEventId");
    const payLoad = {
      "userId": loginUserId || loggedUserDetails?.userId,
      "credentialingEventId": credentialingEventId,
      "pageNumber": pageNumber,
      "pageSize": pageSize
    }
    this.service.getTinDetails(payLoad).subscribe({
      next: (response: any) => {
        this.loader.hide();
        const taxEntityRows = this.getTaxEntityRowsFromResponse(response);
        const mappedData = taxEntityRows.map((item: any) => ({
          ...item,
          IsTinFromDW: item?.isTinFromDW ? "Yes" : "No",
          delete: (!item?.isTinFromDW || this.getDeleteStatus(item?.taxId ?? item?.tin)) ? 'delete' : ''
        }));
        const updatedTINs = mappedData.map((tin: any) => ({
          ...tin
        }));
        this.tinData = [...updatedTINs];
        localStorage.setItem('taxEntities', JSON.stringify(taxEntityRows));
        localStorage.setItem('TINDetails', JSON.stringify(this.buildTinDetailsFromTaxEntities(taxEntityRows)));
        this.updateTinTableView(resetToFirstPage);
      },
      error: (err: any) => {
        this.loader.hide();
        if (err?.status === 404) {
          this.tinData = [];
          this.originalTinData = [];
          this.tinTotalRecords = 0;
          localStorage.setItem('TINDetails', JSON.stringify([]));
          this.updateTinTableView(resetToFirstPage);
          return;
        }
        this.service.logError("APIFailed", "FileLocationComponent - getTinDetails, Method:getTin", this.router.url.split('?')[0], err).subscribe();
      }
    });
  }
  private updateTinTableView(resetToFirstPage: boolean = false) {
    const searchText = this.tinFilterText;
    const filteredTinData = !searchText
      ? [...this.tinData]
      : this.tinData.filter((item: any) =>
        (item.taxId ?? '').toLowerCase().includes(searchText) ||
        (item.taxEntityName ?? '').toLowerCase().includes(searchText) ||
        (item.taxEntityAddress1 ?? '').toLowerCase().includes(searchText) ||
        (item.taxEntityCity ?? '').toLowerCase().includes(searchText) ||
        (item.taxEntityState ?? '').toLowerCase().includes(searchText)
      );

    const orderedTinData = this.sortTinWithTopPriority(filteredTinData);

    this.originalTinData = [...orderedTinData];
    this.tinTotalRecords = orderedTinData.length;

    if (resetToFirstPage) {
      this.currentTinPageIndex = 0;
    }

    const maxTinPageIndex = Math.max(0, Math.ceil(this.tinTotalRecords / this.currentTinPageSize) - 1);
    this.currentTinPageIndex = Math.min(this.currentTinPageIndex, maxTinPageIndex);

    const start = this.currentTinPageIndex * this.currentTinPageSize;
    this.tinDataSource.data = orderedTinData.slice(start, start + this.currentTinPageSize);
  }
  getDeleteStatus(taxId:any){
    const normalizedTin = this.normalizeTinIdentifier(taxId);
    if (!normalizedTin) {
      return false;
    }

    const whLocations = JSON.parse(localStorage.getItem('whLocations') || '[]');
    const hasExistingDwLocation = Array.isArray(whLocations) && whLocations.some(
      (loc: any) => this.normalizeTinIdentifier(loc?.tin) === normalizedTin
    );
    if (hasExistingDwLocation) {
      return false;
    }

    const locations = JSON.parse(localStorage.getItem('locations') || '[]');
    const filteredLocations = Array.isArray(locations)
      ? locations.filter((loc: any) => this.normalizeTinIdentifier(loc?.tin) === normalizedTin)
      : [];

    return filteredLocations.length > 0 &&
      filteredLocations.every(
        (loc: any) => Object.prototype.hasOwnProperty.call(loc, 'isLocationFromTINSearch') && loc.isLocationFromTINSearch !== null
      );
  }
}
